import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { FormControl, FormGroup } from '@angular/forms';
import { AlertService } from '../common/services/alert.service';
import { ModalController, Platform } from '@ionic/angular';
import { ActivationComponent } from '../activation/activation.component';
import { ActivationService } from '../common/services/activation.service';
import { ActivatedRoute } from '@angular/router';
import {ForgotPasswordComponent} from "./forgot-password/forgot-password.component";

@Component({
  selector: 'sol-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  passwordVisible = false;
  loginForm: FormGroup = new FormGroup({
    email: new FormControl(),
    password: new FormControl(),
  });
  private readonly cardID: string | undefined;

  constructor(
    route: ActivatedRoute,
    private loginService: LoginService,
    private alertService: AlertService,
    private modalCtrl: ModalController,
    public platform: Platform,
    private activationService: ActivationService,
  ) {
    this.cardID = route.snapshot.params?.['id'];
  }

  ngOnInit(): void {
    if (this.cardID) {
      this.loadActivation().then();
    }
  }

  async onUserLogin(): Promise<void> {
    await this.loginService
      .loginUser(this.loginForm.get('email')?.value, this.loginForm.get('password')?.value);
  }

  togglePasswordVisibility() {
    this.passwordVisible = !this.passwordVisible;
  }

  async showForgotPassword(): Promise<void> {
    const m = await this.modalCtrl.create({
      component: ForgotPasswordComponent,
      mode: 'ios',
      presentingElement: document.querySelector('.ion-page') as HTMLElement,
      handleBehavior: 'cycle',
      showBackdrop: true,
      canDismiss: true,
    });
    await m.present();
  }

  /**
   * Carrega o modal de ativação. Apenas é disparado caso
   * o usuário esteja tentando ativar um perfil.
   */
  private async loadActivation(): Promise<void> {
    let initBreakPoint;
    if (this.platform.height() >= 581 && this.platform.height() <= 667) {
      initBreakPoint = .60
    } else if(this.platform.height() <= 580 && this.platform.is('desktop')) {
      initBreakPoint = .90
    } else {
      initBreakPoint = .48
    }
    const m = await this.modalCtrl.create({
      componentProps: { data: {cardID: this.cardID}},
      component: ActivationComponent,
      initialBreakpoint: initBreakPoint,
      breakpoints: [.60, .80],
      handle: true,
      cssClass: ['custom-modal'],
      animated: true,
      canDismiss: true,
      backdropDismiss: false,
    });
    await m.present();
    /**
     * Expande o modal para melhor user experience com
     * base em um observable quem vem do ActivationService.
     */
    if (!this.platform.is('desktop')) {
      this.activationService.expandModal.subscribe({
        next(value: any) {
          if (value) {
            m?.setCurrentBreakpoint(.80)
          }
        }
      })
    }
  }
}
